import styled from 'styled-components';
import { device } from '../../styles/devices';
import { color, gutter } from '../../styles/mixins';

const Host = styled.div`
  position: relative;
  aspect-ratio: 16/9;

  display: flex;
  justify-content: flex-start;
  align-items: flex-end;

  padding: ${gutter(6)} ${gutter(3)};

  color: ${color('white')};

  @media ${device.tablet} {
    height: calc(100vh - 76px);
    width: 100%;
  }

  &:after {
    content: '';
    display: block;
    position: absolute;
    z-index: 0;
    bottom: 0;
    right: 0;
    left: 0;
    height: 190px;
    max-height: 100%;
    background: linear-gradient(
      0deg,
      rgba(0, 0, 0, 1) 0%,
      rgba(0, 0, 0, 0) 100%
    );
  }

  iframe {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }
`;

interface ImageLargeProps {
  youTubeId: string;
}

export const VideoLarge = ({ youTubeId }: ImageLargeProps) => {
  return (
    <Host>
      <iframe
        title="Napa Valley video"
        width="100%"
        height="100%"
        src={`https://www.youtube-nocookie.com/embed/${youTubeId}?&amp;autoplay=0&amp;autohide=1&amp;controls=0&amp;modestbranding=1&amp;rel=0&amp;showinfo=0`}
        frameBorder="0"
        allow="autoplay; encrypted-media"
        allowFullScreen
      ></iframe>
    </Host>
  );
};
